import React from 'react'
import { bool, string } from 'prop-types'

import Relazsizes from 'relazsizes'
import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'

const StickyBasicContent = ({
  logo,
  title,
  noTitle,
  buttonVariant,
  href,
  buttonText,
}) => (
  <div className="sticky-basic-content">
    {
      logo &&
      <div className="sticky-basic-content__profile">
        <Relazsizes src={logo} className="sticky-basic-content__logo" />
      </div>
    }
    {
      (!noTitle && title) &&
      <Typography
        variant="body"
        component="div"
        className="m-y-sm font-weight-bold sticky-basic-content__title"
      >
        {title}
      </Typography>
    }
    <Button
      component="a"
      variant={buttonVariant}
      href={href}
      target="_blank"
      rel="noopener norefferer"
      className="sticky-basic-content__button"
    >
      {buttonText}
    </Button>
    <style jsx>
      {`
        .sticky-basic-content {
          display: flex;
          align-items: center;

          &__profile {
            display: none;
            @media screen and (min-width: 768px) {
              display: flex;
              flex-grow: 1;
              align-items: center;
            }
          }
          :global(&__title) {
            flex-grow: 1;
          }

          :global(&__button) {
            font-weight: bold;
            box-shadow: rgba(107, 143, 188, 0.85) 0px 2px 4px 0;
            padding: 14px 28px;
            margin: 8px;
          }
          
          :global(&__logo) {
            max-height: 40px;
          }

          @media(max-width: 767px){
            justify-content: center;

            :global(&__title) {
              display: none;
            }

            :global(&__button) {
              flex-grow: 1;
            }
          }
        }
      `}
    </style>
  </div>
)

StickyBasicContent.propTypes = {
  title: string,
  buttonVariant: string,
  href: string,
  buttonText: string,
  logo: string,
  noTitle: bool,
}

StickyBasicContent.defaultProps = {
  buttonVariant: 'default',
  noTitle: false,
}
export default StickyBasicContent
